import {images} from './images'
import {CategoryDetails, Category, MetaTagsProps} from "@/types";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import {
    Camera,
    Video,
    Palette,
} from 'lucide-react';
import {category as service1, createMetaTags as tags1} from "./1";
import {category as service2, createMetaTags as tags2} from "./2";
import {category as service3, createMetaTags as tags3} from "./3";
import {category as service4, createMetaTags as tags4} from "./4";
import {category as service5, createMetaTags as tags5} from "./5";
import {BUSINESS_NAME, OG_PATH, WEBSITE_URL} from "@/content";

const categoryId = 2

export const headCategory: Category = {
    id: categoryId,
    key: 'electrical',
    name: 'Excavation & Structural Construction',
    long_name: 'Excavation & Structural Construction',
    slug: 'excavation-and-structural-construction-sydney',
    categoryType: 'services',
}

export const metaTags: MetaTagsProps = {
    title: `Excavation & Structural Construction Sydney | ${BUSINESS_NAME}`,
    description: "From detailed excavation to large-scale structural works, we offer safe and efficient services tailored to Sydney’s residential, commercial, and civil projects. Our expertise covers basements, retaining systems, and complex infrastructure builds with dependable results.",
    keywords: "excavation services Sydney, structural construction Sydney, basement excavation, retaining wall construction, civil excavation, residential excavation, commercial excavation, site preparation Sydney, earthworks Sydney, foundation excavation, trenching services, bulk excavation, Sydney construction services",
    url: `${WEBSITE_URL}/${headCategory.categoryType}/${headCategory.slug}`,
    ogImage: `${OG_PATH}c${categoryId}.jpg`,
    type: "website",
}
export const subCategoryObject = Object.fromEntries(
    Object.entries({
        category2Service1: {...service1, ...tags1(metaTags)},
        category2Service2: {...service2, ...tags2(metaTags)},
        category2Service3: {...service3, ...tags3(metaTags)},
        category2Service4: {...service4, ...tags4(metaTags)},
        category2Service5: {...service5, ...tags5(metaTags)}
    }).map(([key, value]) => [key, {...value, headCategory}])
);

const subCategories = Object.values(subCategoryObject);

export const categoryDetails: CategoryDetails = {
    ...headCategory,
    metaTags,
    order: 1,
    icon: <EmojiEventsIcon/>,
    points: [
        {
            title: '',
            icon: Camera,
        },
        {
            title: '',
            icon: Video,
        },
        {
            title: '',
            icon: Palette,
        },
    ],
    description: ['From detailed excavation to large-scale structural works, we offer safe and efficient services tailored to Sydney’s residential, commercial, and civil projects. Our expertise covers basements, retaining systems, and complex infrastructure builds with dependable results.'],
    videos: [],
    images: images.map((image, index) => ({
        ...image,
        alt: `${headCategory.slug}-${index + 1}`,
    })),
    subCategories,
}
